module.exports = __webpack_public_path__ + "static/media/bothImg.0d4760b0.png";